// Auto generated file, do not manually modify!
// com.hotpads.rins.api.web.handler.ProofOfInsuranceWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  ProofOfInsuranceWebApiHandler_getTenantsList,
  ProofOfInsuranceWebApiHandler_getTenantsList_Path,
  ProofOfInsuranceWebApiHandler_sendProofRequestEmail,
} from '@zg-rentals/ts-rins-client';

import type {
  EmailRequestResultDto,
  GetTenantsListWebApiRequestDto,
  GetTenantsListWebApiResponseDto,
  SendProofRequestWebApiRequestDto,
} from '@zg-rentals/ts-rins-client';

type ProofOfInsuranceWebApiHandler_getTenantsList_Options = UseQueryOptions<
  GetTenantsListWebApiResponseDto,
  unknown,
  GetTenantsListWebApiResponseDto,
  Array<string | GetTenantsListWebApiRequestDto>
>;

const ProofOfInsuranceWebApiHandler_getTenantsList_GetKey = (postData: GetTenantsListWebApiRequestDto) => [
  ProofOfInsuranceWebApiHandler_getTenantsList_Path,
  postData,
];

/**
 * Get a list of tenants with the request status
 */
export const useProofOfInsuranceWebApiHandler_getTenantsList = (
  postData: GetTenantsListWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ProofOfInsuranceWebApiHandler_getTenantsList_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ProofOfInsuranceWebApiHandler_getTenantsList_GetKey(postData),
    queryFn: () => ProofOfInsuranceWebApiHandler_getTenantsList(postData, httpClient),
  });
};
useProofOfInsuranceWebApiHandler_getTenantsList.getKey = ProofOfInsuranceWebApiHandler_getTenantsList_GetKey;

interface ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Args {
  postData: SendProofRequestWebApiRequestDto;
}

type ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Options = UseMutationOptions<
  EmailRequestResultDto,
  unknown,
  ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Args
>;

/**
 * Send an email reminder to Rachels to upload their proof of insurance
 */
export const useProofOfInsuranceWebApiHandler_sendProofRequestEmail = ({
  httpClient,
  ...options
}: Omit<ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Args) =>
      ProofOfInsuranceWebApiHandler_sendProofRequestEmail(args.postData, httpClient),
  });
};
